import axios from "axios";
const API_KEY = process.env.REACT_APP_CHART_API_KEY;
const isMobileView = document.body.clientWidth <= 768;
let frontend;

if (isMobileView) {
  frontend = "Mobile";
} else {
  frontend = "Web";
}

const getBollingerBandsData = async (
  symbol,
  period,
  length,
  standardDeviation,
  multiplier
) => {
  const endpoint = `https://pro.qushi.io/api/bollingernew?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&length=${length || "5"}&standard_deviation=${standardDeviation || 2
    }${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Bollinger Bands data:", error);
    throw error;
  }
};


const getBollingerBandsDataNew1 = async (
  symbol,
  period,
  length,
  standardDeviation,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/bollingernew?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || 5}&standard_deviation=${standardDeviation || 2}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Bollinger Bands data:", error);
    throw error;
  }
};


const getCandlestickData = async (symbol, startDate, period, multiplier, endDate, limit) => {
  const endpoint = `https://pro.qushi.io/api/candlesticknew?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }${startDate ? `&start_date=${startDate}` : ""}${endDate ? `&end_date=${endDate}` : ""}${limit ? `&limit=${limit}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Candlestick data:", error);
    throw error;
  }
};


// const getCandlestickData = async (symbol, startDate, period, multiplier) => {
//   const endpoint = `https://pro.qushi.io/api/candlesticknew?symbol=${symbol || "AAPL"
//     }&period=${period || "hour"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
//     }`;
//   try {
//     const response = await axios.get(endpoint, {
//       headers: {
//         APIKEY: API_KEY,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching Candlestick data:", error);
//     throw error;
//   }
// };



const getAdlData = async (symbol, period, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/adl?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Adl data:", error);
    throw error;
  }
};

const getParabolicSARData = async (
  symbol,
  period,
  initialAcceleration,
  acceleration,
  maxAcceleration,
  multiplier
) => {
  const endpoint = `https://pro.qushi.io/api/psar?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&initial_acceleration=${initialAcceleration || "0.02"
    }&acceleration=${acceleration || "0.02"}&max_acceleration=${maxAcceleration || "0.2"
    }${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching PSAR data:", error);
    throw error;
  }
};

const getCCIData = async (
  symbol,
  period,
  length,
  cciScalingConstant,
  multiplier
) => {
  const endpoint = `https://pro.qushi.io/api/cci?symbol=${symbol || "AAPL"
    }&period=${period || "90"}&length=${length || "14"}&cci_scaling_constant=${cciScalingConstant || "0.015"
    }${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching CCI data:", error);
    throw error;
  }
};

const getCMFData = async (symbol, period, length, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/cmf?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&length=${length || "14"}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching CCI data:", error);
    throw error;
  }
};

const getEMAData = async (symbol, period, length, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/ema?symbol=${symbol || "AAPL"
    }&period=${period || "90"}&length=${length || "14"}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching CCI data:", error);
    throw error;
  }
};

const getEMADataNew1 = async (
  symbol,
  period,
  length,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/ema?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || 14}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getMACDData = async (symbol, period, fast, slow, signal, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/macd?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&fast=${fast || "12"}&slow=${slow || "25"
    }&signal=${signal || "9"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching FIP data:", error);
    throw error;
  }
};

const getMACDHData = async (symbol, period, multiplier, fast, slow, signal) => {
  const endpoint = `https://pro.qushi.io/api/macd?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }${fast ? `&fast=${fast}` : ""}${slow ? `&slow=${slow}` : ""}${signal ? `&smooth_k=${signal}` : ""}\`;`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching FIP data:", error);
    throw error;
  }
};

const getEFIData = async (symbol, period, length, drift, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/efi?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&length=${length || "13"}&drift=${drift || "1"}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching EFI data:", error);
    throw error;
  }
};

const getMFIData = async (symbol, period, length, drift, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/mfi?symbol=${symbol || "AAPL"
    }&period=${period || "90"}&length=${length || "14"}&drift=${drift || "1"}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching MFI data:", error);
    throw error;
  }
};

const getOBVData = async (symbol, period, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/obv?symbol=${symbol || "AAPL"
    }&period=${period || "90"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""
    }`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching OBV data:", error);
    throw error;
  }
};

const getROCData = async (symbol, period, length, scalar, multiplier) => {
  let endpoint = `https://pro.qushi.io/api/roc?symbol=${symbol || "AAPL"}&period=${period || "90"}&length=${length || "1"}&scalar=${scalar || "100"}`;

  if (multiplier) {
    endpoint += `&multiplier=${multiplier}`;
  }

  if (frontend) {
    endpoint += `&frontend=${frontend}`;
  }

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ROC data:", error);
    throw error;
  }
};

const getSMAData = async (symbol, period, length, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/sma?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&length=${length || 10}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ROC data:", error);
    throw error;
  }
};

 const getSMADataNew1 = async (
  symbol,
  period,
  length,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/sma?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || 10}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getSTOCHData = async (symbol, period, multiplier, fast, slow, smooth_k) => {
  const endpoint = `https://pro.qushi.io/api/stoch?symbol=${symbol || "AAPL"
  }&period=${period || "hour"}${multiplier ? `&multiplier=${multiplier}` : ""}${frontend ? `&frontend=${frontend}` : ""}${fast ? `&fast=${fast}` : ""}${slow ? `&slow=${slow}` : ""}${smooth_k ? `&smooth_k=${smooth_k}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching stoch data:", error);
    throw error;
  }
};

const getRSIData = async (symbol, period, length, multiplier) => {
  const endpoint = `https://pro.qushi.io/api/rsi?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&length=${length || "14"}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ROC data:", error);
    throw error;
  }
};

const getADXData = async (
  symbol,
  period,
  length,
  scalar,
  drift,
  lensig,
  multiplier
) => {
  const endpoint = `https://pro.qushi.io/api/adx?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&length=${length || 10}&scalar=${scalar || 100
    }&drift=${drift || 1}&lensig=${lensig || 14}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ROC data:", error);
    throw error;
  }
};
const getPsarData = async (
  symbol,
  period,
  initialAcceleration,
  acceleration,
  multiplier
) => {
  const endpoint = `https://pro.qushi.io/api/psar?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&initial_acceleration=${initialAcceleration || "0.02"
    }&acceleration=${acceleration || "0.02"}${multiplier ? `&multiplier=${multiplier}` : ""
    }${frontend ? `&frontend=${frontend}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ROC data:", error);
    throw error;
  }
};

 const getPsarDataNew1 = async (
  symbol,
  period,
  initialAcceleration,
  acceleration,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/psar?symbol=${symbol || "AAPL"}&period=${period || "hour"}&initial_acceleration=${initialAcceleration || 0.02}&acceleration=${acceleration || 0.02}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

// ==================== NEW INDICATOR FUNCTIONS WITH LAZY LOADING ====================

const getAdlDataNew1 = async (
  symbol,
  period,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/adl?symbol=${symbol || "AAPL"}&period=${period || "hour"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getCCIDataNew1 = async (
  symbol,
  period,
  length,
  cciScalingConstant,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/cci?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || "14"}&cci_scaling_constant=${cciScalingConstant || "0.015"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getCMFDataNew1 = async (
  symbol,
  period,
  length,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/cmf?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || "14"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getMACDDataNew1 = async (
  symbol,
  period,
  fast,
  slow,
  signal,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/macd?symbol=${symbol || "AAPL"}&period=${period || "hour"}&fast=${fast || "12"}&slow=${slow || "26"}&signal=${signal || "9"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getMACDHDataNew1 = async (
  symbol,
  period,
  multiplier,
  fast,
  slow,
  signal,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/macd?symbol=${symbol || "AAPL"}&period=${period || "hour"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${fast ? `&fast=${fast}` : ""}${slow ? `&slow=${slow}` : ""}${signal ? `&smooth_k=${signal}` : ""}${
    startDate ? `&start_date=${startDate}` : ""
  }${endDate ? `&end_date=${endDate}` : ""}${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getEFIDataNew1 = async (
  symbol,
  period,
  length,
  drift,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/efi?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || "13"}&drift=${drift || "1"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getMFIDataNew1 = async (
  symbol,
  period,
  length,
  drift,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/mfi?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || "14"}&drift=${drift || "1"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getOBVDataNew1 = async (
  symbol,
  period,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/obv?symbol=${symbol || "AAPL"}&period=${period || "hour"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getROCDataNew1 = async (
  symbol,
  period,
  length,
  scalar,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/roc?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || "1"}&scalar=${scalar || "100"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getSTOCHDataNew1 = async (
  symbol,
  period,
  multiplier,
  fast,
  slow,
  smooth_k,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/stoch?symbol=${symbol || "AAPL"}&period=${period || "hour"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${fast ? `&fast=${fast}` : ""}${slow ? `&slow=${slow}` : ""}${smooth_k ? `&smooth_k=${smooth_k}` : ""}${
    startDate ? `&start_date=${startDate}` : ""
  }${endDate ? `&end_date=${endDate}` : ""}${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getRSIDataNew1 = async (
  symbol,
  period,
  length,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/rsi?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || "14"}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getADXDataNew1 = async (
  symbol,
  period,
  length,
  scalar,
  drift,
  lensig,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/adx?symbol=${symbol || "AAPL"}&period=${period || "hour"}&length=${length || 10}&scalar=${scalar || 100}&drift=${drift || 1}&lensig=${lensig || 14}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getPPODataNew1 = async (
  symbol,
  period,
  fast,
  slow,
  signal,
  scalar,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/ppo?symbol=${symbol || "AAPL"}&period=${period || "hour"}&fast=${fast || 12}&slow=${slow || 26}&signal=${signal || 9}&scalar=${scalar || 100}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }${startDate ? `&start_date=${startDate}` : ""}${
    endDate ? `&end_date=${endDate}` : ""
  }${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

const getPVODataNew1 = async (
  symbol,
  period,
  fast,
  slow,
  signal,
  scalar,
  startDate,
  endDate,
  limit
) => {
  const endpoint = `https://pro.qushi.io/api/pvo?symbol=${symbol || "AAPL"}&period=${period || "hour"}&fast=${fast || 12}&slow=${slow || 26}&signal=${signal || 9}&scalar=${scalar || 100}${
    startDate ? `&start_date=${startDate}` : ""
  }${endDate ? `&end_date=${endDate}` : ""}${limit ? `&limit=${limit}` : ""}&frontend=Mobile`;

  const response = await axios.get(endpoint, {
    headers: {
      APIKEY: API_KEY,
    },
  });

  return response.data;
};

// const getPPOData = async (symbol, period, fast, slow, signal, scalar) => {
//   const endpoint = `https://pro.qushi.io/api/ppo?symbol=${symbol || "AAPL"
//     }&period=${period || "hour"}&fast=${fast || 12}&slow=${slow || 26}&signal=${signal || 9
//     }&scalar=${scalar || 100}${frontend ? `&frontend=${frontend}` : ""}`;
//   try {
//     const response = await axios.get(endpoint, {
//       headers: {
//         APIKEY: API_KEY,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching ROC data:", error);
//     throw error;
//   }
// };

const getPPOData = async (symbol, period, fast, slow, signal, scalar) => {
  // ✅ Decide multiplier based on period
  const multiplier =
    ["day", "week", "month"].includes(period) ? 1 : (scalar || 26);

  const endpoint = `https://pro.qushi.io/api/ppo?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&fast=${fast || 12}&slow=${slow || 26}&multiplier=${multiplier}&signal=${signal || 9
    }&scalar=${scalar || 100}${frontend ? `&frontend=${frontend}` : ""}`;

  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching PPO data:", error);
    throw error;
  }
};


const getPVOData = async (symbol, period, fast, slow, signal, scalar) => {
  const endpoint = `https://pro.qushi.io/api/pvo?symbol=${symbol || "AAPL"
    }&period=${period || "hour"}&fast=${fast || 12}&slow=${slow || 26}&signal=${signal || 9
    }&scalar=${scalar || 100}${frontend ? `&frontend=${frontend}` : ""}`;
  try {
    const response = await axios.get(endpoint, {
      headers: {
        APIKEY: API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching ROC data:", error);
    throw error;
  }
};

export {
  getBollingerBandsData,
  getCandlestickData,
  getPVOData,
  getParabolicSARData,
  getROCData,
  getPPOData,
  getCCIData,
  getEFIData,
  getMFIData,
  getOBVData,
  getSMAData,
  getEMAData,
  getADXData,
  getPsarData,
  getAdlData,
  getSTOCHData,
  getRSIData,
  getCMFData,
  getMACDData,
  getMACDHData,
  getBollingerBandsDataNew1,
  getSMADataNew1,
  getEMADataNew1,
  getPsarDataNew1,
  // New indicator functions with lazy loading
  getAdlDataNew1,
  getCCIDataNew1,
  getCMFDataNew1,
  getMACDDataNew1,
  getMACDHDataNew1,
  getEFIDataNew1,
  getMFIDataNew1,
  getOBVDataNew1,
  getROCDataNew1,
  getSTOCHDataNew1,
  getRSIDataNew1,
  getADXDataNew1,
  getPPODataNew1,
  getPVODataNew1,
};
